import { slidesField } from "../../../../config/common/slidesField";
var slides = [slidesField];